import { render, staticRenderFns } from "./shutdown.vue?vue&type=template&id=2c876aff&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c876aff",
  null
  
)

export default component.exports